import { useAccount } from '../../contexts/authContext'

function useAccountLoyaltySettings() {
  const {
    account: { loyaltySettings },
  } = useAccount()
  const canLogPoints = loyaltySettings.logPoints.enabled
  const canRedeemMultiple = loyaltySettings.redeemMultiple.enabled

  return { canLogPoints, canRedeemMultiple }
}

function useLoyaltyRestrictions() {
  const { canLogPoints, canRedeemMultiple } = useAccountLoyaltySettings()
  return {
    canLogPoints: !canLogPoints,
    canRedeemMultiple: !canRedeemMultiple,
  }
}

export { useLoyaltyRestrictions }
